// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"520":"4c1d0f70","2358":"28819987","3536":"28819987","7402":"28819987"}[chunkId] + ".chunk.css");